import React from "react";

import "@styles/c-subtitlesDisplay.scss";

interface Props {
  subtitlesText: string;
  className?: string;
}

export class SubtitlesDisplayComponent extends React.Component<Props> {
  private static BASE_FONT_SIZE = 14;
  private static MIN_FONT_SIZE = 10;
  private static MAX_FONT_SIZE = 28;
  private static BASE_WIDTH = 500;
  private static MIN_WIDTH = 330;
  private static MAX_WIDTH = 1280;

  private html: HTMLDivElement;

  render() {
    const { subtitlesText, className } = this.props;
    return (
      <div className={`${className || ""} c-subtitlesDisplay`} ref={(element) => (this.html = element)}>
        <div
          className="c-subtitlesDisplay__container"
          style={{
            fontSize: `${this.calculateFontSize()}px`,
          }}
          dangerouslySetInnerHTML={{ __html: subtitlesText }}
        />
      </div>
    );
  }

  private calculateFontSize(): number {
    if (!this.html) {
      return;
    }

    const calculatedSize =
      this.html.clientWidth < SubtitlesDisplayComponent.BASE_WIDTH
        ? SubtitlesDisplayComponent.MIN_FONT_SIZE +
          ((this.html.clientWidth - SubtitlesDisplayComponent.MIN_WIDTH) *
            (SubtitlesDisplayComponent.BASE_FONT_SIZE - SubtitlesDisplayComponent.MIN_FONT_SIZE)) /
            (SubtitlesDisplayComponent.BASE_WIDTH - SubtitlesDisplayComponent.MIN_WIDTH)
        : SubtitlesDisplayComponent.BASE_FONT_SIZE +
          ((this.html.clientWidth - SubtitlesDisplayComponent.BASE_WIDTH) *
            (SubtitlesDisplayComponent.MAX_FONT_SIZE - SubtitlesDisplayComponent.BASE_FONT_SIZE)) /
            (SubtitlesDisplayComponent.MAX_WIDTH - SubtitlesDisplayComponent.BASE_WIDTH);

    return Math.max(SubtitlesDisplayComponent.MIN_FONT_SIZE, Math.min(SubtitlesDisplayComponent.MAX_FONT_SIZE, calculatedSize));
  }
}
